
import React, { useState } from "react";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";

interface ApproveClassDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (status: "approved" | "rejected", note: string) => Promise<void>;
  loading?: boolean;
  value?: { status: "approved" | "rejected", note?: string };
}

export const ApproveClassDialog: React.FC<ApproveClassDialogProps> = ({
  open,
  onOpenChange,
  onSubmit,
  loading,
  value,
}) => {
  const [note, setNote] = useState(value?.note || "");
  const [status, setStatus] = useState<"approved" | "rejected">(value?.status || "approved");

  const handleApprove = async () => {
    await onSubmit(status, note);
    setNote("");
    setStatus("approved");
    onOpenChange(false);
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>ยืนยันการดำเนินการคลาสเฉพาะกิจ</AlertDialogTitle>
          <AlertDialogDescription>
            โปรดเลือกสถานะ และกรอกหมายเหตุ (ถ้ามี) สำหรับคลาสเฉพาะกิจนี้
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="flex gap-3 items-center mb-2">
          <label>
            <input
              type="radio"
              name="status"
              value="approved"
              className="mr-1"
              checked={status === "approved"}
              onChange={() => setStatus("approved")}
              disabled={loading}
            />{" "}
            อนุมัติ
          </label>
          <label>
            <input
              type="radio"
              name="status"
              value="rejected"
              className="mr-1"
              checked={status === "rejected"}
              onChange={() => setStatus("rejected")}
              disabled={loading}
            />{" "}
            ไม่อนุมัติ
          </label>
        </div>
        <Textarea
          placeholder="หมายเหตุ (ถ้ามี)"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          rows={3}
        />
        <AlertDialogFooter>
          <AlertDialogCancel disabled={loading}>ยกเลิก</AlertDialogCancel>
          <AlertDialogAction onClick={handleApprove} disabled={loading}>
            {loading ? "กำลังบันทึก..." : "ยืนยัน"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
